<template>
  <li class="cursor-pointer p-2 px-4 hover:underline">
    <router-link
      class="text-blue-darkest pl-8 no-underline block"
      :to="to"
    >
      <slot></slot>
    </router-link>
  </li>
</template>

<script>
export default {
  props: ["to"]
};
</script>




// WEBPACK FOOTER //
// MenuItemLink.vue?71c61c7e